import React from 'react';

import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { SettingDisplay } from 'lib/SettingDisplay';
import { CreatableChipInputFormField } from 'lib/form/fields/CreatableChipInputFormField';

export const EagleEyeGiftCardSettingsEdit: React.FC<IPointOfSaleSettingsProps> = ({ locationId }) => (
    <>
        {/* Common Only */}
        {locationId === undefined && (
            <SettingDisplay label="Campaign Ids">
                <CreatableChipInputFormField
                    name="eagleEyeGiftCardFullRedemptionOnlyCampaignIds"
                    placeholder=""
                    limitTags={4}
                    maxInputHeight={100}
                />
            </SettingDisplay>
        )}
    </>
);
